import * as Sentry from "@sentry/react";

const getShouldInitSentry = (env: string | undefined) => {
  return env === "production" || env === "staging";
};

if (getShouldInitSentry(`${import.meta.env.VITE_APP_ENVIRONMENT}`)) {
  Sentry.init({
    dsn: "https://1da2805e38404bb18f259ef1d57938ff@o192177.ingest.us.sentry.io/5975777",
    tracesSampleRate: 0,
    environment: `${import.meta.env.VITE_APP_ENVIRONMENT}`,
    release: `${import.meta.env.VITE_APP_RELEASE}`,
    beforeSend: (event) => {
      const exception = event.exception?.values && event.exception?.values[0];
      if (
        exception?.value?.startsWith(
          "Non-Error promise rejection captured with"
        ) ||
        exception?.value?.includes(
          'The method "isDefaultWallet" does not exist'
        ) ||
        exception?.value?.includes("nkbihfbeogaeaoehlefnkodbefgpgknn") ||
        exception?.value?.includes("TelegramGameProxy")
      ) {
        return null;
      }
      return event;
    },
  });
}

// Helper function to capture Telegram SDK errors with context
export const captureTelegramError = (
  error: unknown,
  context: {
    method: string;
    location: string;
    additionalData?: Record<string, unknown>;
  }
) => {
  const stack = error instanceof Error ? error.stack : new Error().stack;

  Sentry.withScope((scope) => {
    const launchParams = context.additionalData?.launchParams;
    const additionalData = { ...context.additionalData };
    if (additionalData.launchParams) {
      delete additionalData.launchParams;
    }

    scope.setContext("telegram_sdk", {
      method: context.method,
      location: context.location,
      stack,
      ...additionalData,
    });

    if (launchParams) {
      scope.setContext(
        "telegram_launch_params",
        launchParams as Record<string, unknown>
      );
    }

    scope.setTag("telegram_error", true);
    scope.setTag("telegram_method", context.method);
    scope.setLevel("error");

    const message = error instanceof Error ? error.message : String(error);
    if (message.includes("Method not found")) {
      scope.setTag("error_type", "method_not_found");
    }

    const errorName =
      error instanceof Error
        ? error.name
        : typeof error === "object" && error !== null && "name" in error
        ? (error as any).name
        : undefined;

    if (
      message.includes("Java object is gone") ||
      errorName === "UnknownEnvError"
    ) {
      scope.setTag(
        "error_type",
        errorName === "UnknownEnvError" ? "unknown_env" : "java_object_gone"
      );
      scope.setLevel("warning");
    }

    if (error instanceof Error) {
      Sentry.captureException(error);
    } else {
      Sentry.captureMessage(`Telegram SDK Error: ${message}`);
    }
  });
};
